let initialState = {
    examList: [],
    isLoading: true,
    isStudentLoading: true,
    isExamReportLoading: true,
}

export default function examReducer(state = initialState, action) {
    let stateCopy = JSON.parse(JSON.stringify(state));
    switch (action.type) {
        case 'Get_Exam_List':
            stateCopy.examList = action.payload.data;
            stateCopy.examPagination = action.payload.pagination;
            stateCopy.isLoading = false;
            return stateCopy;
        case 'Reset_Exam_List':
            stateCopy.examList = [];
            stateCopy.isLoading = true;
            stateCopy.examPagination = {};
            return stateCopy;
        case 'Change_Exam_Status':
            stateCopy.examList.forEach(answer => {
                if (answer._id === action.payload.id) {
                answer.active = !action.payload.checked;
                }
            })
            return stateCopy;
        case 'Get_Student_Exam_List':
            stateCopy.studentExamList = action.payload.data;
            stateCopy.isStudentLoading = false;
            stateCopy.studentPagination = action.payload.pagination;
            stateCopy.studentExamServerTime = action.payload.serverTime;
            return stateCopy;
        case 'Get_Exam_Report':
            stateCopy.examReport = action.payload.data.map(el => [{ name: el.name, email: el.email, score: el.score, _id: el.user_id }][0]);
            stateCopy.isExamReportLoading = false;
            stateCopy.examReportPagination = action.payload.pagination;
            return stateCopy;
        default:
            return stateCopy;
    }
}